import { ApplyCouponArr } from "./apply/coupon";
import { ApplyCar } from "./apply/carCertification";
import { ApplyCouponSettingArr } from "./apply/couponSetting";
import { ApplyEmployeeArr } from "./apply/employee";
import { ApplyDistributeArr } from "./apply/distribute";
import { ApplyForumArr } from "./apply/forum";
import { ApplyFullPackageArr } from "./apply/fullPackage";
import { ApplyFullReductionArr } from "./apply/fullReduction";
import { ApplyGoodsGroupArr } from "./apply/GoodsGroup";
import { ApplyIntegralMallArr } from "./apply/integralMall";
import { ApplyLuckyDrawArr } from "./apply/luckyDraw";
import { ApplyMallArr } from "./apply/mall";
import { ApplyMerchantArr } from "./apply/merchant";
import { ApplyPointArr } from "./apply/point";
import { ApplySignArr } from "./apply/sign";
import { ApplyStoreManageArr } from "./apply/storeManage";
import { ApplyVipArr } from "./apply/vip";
import { ApplypageLimit } from "./apply/pageLimit"; //页面权限
const applyCenter = [
  ...ApplyCouponArr, // 优惠券
  ...ApplyCouponSettingArr, // 优惠券设置
  ...ApplyEmployeeArr, // 员工管理
  ...ApplyDistributeArr, // 分销
  ...ApplyForumArr, // 论坛
  ...ApplyFullPackageArr, // 满包邮
  ...ApplyFullReductionArr, // 满减
  ...ApplyGoodsGroupArr, // 团购
  ...ApplyIntegralMallArr, // 积分商城
  ...ApplyLuckyDrawArr, // 员工管理
  ...ApplyMallArr, // 商城
  ...ApplyMerchantArr, // 多商户
  ...ApplySignArr, // 签到
  ...ApplyStoreManageArr, // 门店
  ...ApplyPointArr, // 积分设置
  ...ApplyVipArr,
  ...ApplypageLimit,
  ...ApplyCar,
  {
    path: "viewapp",
    name: "viewapp",
    meta: {
      title: "分类"
    },
    component: () => import("@/views/apply/index.vue")
  },
  {
    path: "vipdata",
    name: "vipdata",
    component: () => import("@/views/apply/newVip/index.vue")
  },

  {
    path: "storeManage/:id(\\d+)",
    name: "storeManage/:id(\\d+)",
    meta: {
      title: "门店"
    },
    redirect: "/apply/storeManage/:id(\\d+)/storeList",
    component: () => import("@/views/sidebar/itemFrame.vue"),
    children: [
      {
        path: "storeList",
        name: "storeList",
        meta: {
          title: "门店管理"
        },
        component: () => import("@/views/apply/storeManage/storeList")
      },
      {
        path: "addStore",
        name: "addStore",
        meta: {
          title: "编辑门店"
        },
        component: () => import("@/views/apply/storeManage/addStore")
      }
    ]
  }
];

export default applyCenter;
